// This file is auto-generated. Do not edit manually.

import { Logement } from '../Logement';
import { DiagnosticReponse } from '../../DiagnosticReponse';
import { isNullOrWithSpace } from '../../utils';

export function normalizeDiagnosticFields(logement: Logement): Logement {
  const normalized = { ...logement };

  // Trim and normalize text fields
  normalized.chemExtInfo = isNullOrWithSpace(normalized.chemExtInfo) ? undefined : normalized.chemExtInfo;
  normalized.communInfo = isNullOrWithSpace(normalized.communInfo) ? undefined : normalized.communInfo;
  normalized.statioInfo = isNullOrWithSpace(normalized.statioInfo) ? undefined : normalized.statioInfo;
  normalized.generalInfo = isNullOrWithSpace(normalized.generalInfo) ? undefined : normalized.generalInfo;
  normalized.cuisineInfo = isNullOrWithSpace(normalized.cuisineInfo) ? undefined : normalized.cuisineInfo;
  normalized.chambreInfo = isNullOrWithSpace(normalized.chambreInfo) ? undefined : normalized.chambreInfo;
  normalized.chambresInfo = isNullOrWithSpace(normalized.chambresInfo) ? undefined : normalized.chambresInfo;
  normalized.chambres2Info = isNullOrWithSpace(normalized.chambres2Info) ? undefined : normalized.chambres2Info;
  normalized.chambres3Info = isNullOrWithSpace(normalized.chambres3Info) ? undefined : normalized.chambres3Info;
  normalized.chambres4Info = isNullOrWithSpace(normalized.chambres4Info) ? undefined : normalized.chambres4Info;
  normalized.bainInfo = isNullOrWithSpace(normalized.bainInfo) ? undefined : normalized.bainInfo;
  normalized.logementInfo = isNullOrWithSpace(normalized.logementInfo) ? undefined : normalized.logementInfo;

  // Clear conditional diagnostic fields
  if (!(normalized.chemExtPortillonPresence === DiagnosticReponse.Oui)) {
    normalized.chemExtPortillonAuto = undefined;
  }
  if (!(normalized.chemExtPortillonPresence === DiagnosticReponse.Oui && normalized.chemExtPortillonAuto === DiagnosticReponse.Non)) {
    normalized.chemExtPortillonManu = undefined;
  }
  if (!(normalized.chemExtPortillonAuto === DiagnosticReponse.Oui)) {
    normalized.chemExtPortillonTele = undefined;
  }
  if (!(normalized.communPorteHallPresence === DiagnosticReponse.Oui)) {
    normalized.communPorteVoie = undefined;
  }
  if (!(normalized.communPorteHallPresence === DiagnosticReponse.Oui && normalized.communPorteVoie === DiagnosticReponse.Non)) {
    normalized.communPorteResidence = undefined;
  }
  if (!(normalized.communPorteAuto === DiagnosticReponse.Oui)) {
    normalized.communPorteTele = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSousSolBoxe = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSousSolOuvert = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSousSolArceaux = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSousSolMotorise = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSasInt = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSasSup1m20 = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSasSup1m50 = undefined;
  }
  if (!(normalized.statioSousSol === DiagnosticReponse.Oui)) {
    normalized.statioSasOculus = undefined;
  }
  if (!(normalized.statioSurface === DiagnosticReponse.Oui)) {
    normalized.statioSurfaceArceaux = undefined;
  }
  if (!(normalized.statioSurface === DiagnosticReponse.Oui)) {
    normalized.statioSurfaceMotorise = undefined;
  }
  if (!(normalized.entreePoignee === DiagnosticReponse.Non)) {
    normalized.entreePoigneeRallongee = undefined;
  }
  if (!(normalized.dispositifVoletElec === DiagnosticReponse.Oui)) {
    normalized.dispositifVoletInterrupteur = undefined;
  }
  if (!(normalized.dispositifVoletElec === DiagnosticReponse.Oui)) {
    normalized.dispositifVoletTelecommande = undefined;
  }
  if (!(normalized.generalPoignetPorte === DiagnosticReponse.Non)) {
    normalized.generalPoigneeRallongee = undefined;
  }
  if (!(normalized.cuisineOuverte === DiagnosticReponse.Non)) {
    normalized.cuisineLargeurPorte83 = undefined;
  }
  if (!(normalized.cuisineOuverte === DiagnosticReponse.Non)) {
    normalized.cuisineLargeurPorte90 = undefined;
  }
  if (!(normalized.cuisineOuverte === DiagnosticReponse.Non)) {
    normalized.cuisinePoignetPorte = undefined;
  }
  if (!(normalized.cuisinePoignetPorte === DiagnosticReponse.Non)) {
    normalized.cuisinePoigneeRallongee = undefined;
  }
  if (!(normalized.cuisineOuverte === DiagnosticReponse.Non)) {
    normalized.cuisineEspaceManoeuvre = undefined;
  }
  if (!(normalized.balconOuTerrasse === true)) {
    normalized.terrasseAcces = undefined;
  }
  if (!(normalized.balconOuTerrasse === true)) {
    normalized.terrasseFourreau = undefined;
  }
  if (!(normalized.balconOuTerrasse === true)) {
    normalized.terrasseRessaut = undefined;
  }
  if (!(normalized.balconOuTerrasse === true)) {
    normalized.terrasseRampe = undefined;
  }
  if (!(normalized.jardin === true)) {
    normalized.jardinAcces = undefined;
  }
  if (!(normalized.jardin === true)) {
    normalized.jardinRampe = undefined;
  }
  if (!(normalized.chambrePoignetPorte === DiagnosticReponse.Non)) {
    normalized.chambrePoigneeRallongee = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresLargeurPorte80 = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresLargeurPorte90 = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresPoignetPorte = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui && normalized.chambresPoignetPorte === DiagnosticReponse.Non)) {
    normalized.chambresPoigneeRallongee = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresEspaceManoeuvre = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresRetournement = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresPrisesHautes = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresPrisesBasses = undefined;
  }
  if (!(normalized.chambresSupp1Presence === DiagnosticReponse.Oui)) {
    normalized.chambresInfo = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2LargeurPorte80 = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2LargeurPorte90 = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2PoignetPorte = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui && normalized.chambres2PoignetPorte === DiagnosticReponse.Non)) {
    normalized.chambres2PoigneeRallongee = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2EspaceManoeuvre = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2Retournement = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2PrisesHautes = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2PrisesBasses = undefined;
  }
  if (!(normalized.chambresSupp2Presence === DiagnosticReponse.Oui)) {
    normalized.chambres2Info = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3LargeurPorte80 = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3LargeurPorte90 = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3PoignetPorte = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui && normalized.chambres3PoignetPorte === DiagnosticReponse.Non)) {
    normalized.chambres3PoigneeRallongee = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3EspaceManoeuvre = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3Retournement = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3PrisesHautes = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3PrisesBasses = undefined;
  }
  if (!(normalized.chambresSupp3Presence === DiagnosticReponse.Oui)) {
    normalized.chambres3Info = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4LargeurPorte80 = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4LargeurPorte90 = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4PoignetPorte = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui && normalized.chambres4PoignetPorte === DiagnosticReponse.Non)) {
    normalized.chambres4PoigneeRallongee = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4EspaceManoeuvre = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4Retournement = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4PrisesHautes = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4PrisesBasses = undefined;
  }
  if (!(normalized.chambresSupp4Presence === DiagnosticReponse.Oui)) {
    normalized.chambres4Info = undefined;
  }
  if (!(normalized.bainPoignetPorte === DiagnosticReponse.Non)) {
    normalized.bainPoigneeRallongee = undefined;
  }
  if (!(normalized.doucheReceveurSansRessaut === DiagnosticReponse.Oui)) {
    normalized.doucheItalienne = undefined;
  }
  if (!(normalized.doucheItalienne === DiagnosticReponse.Oui)) {
    normalized.doucheItalienneOk = undefined;
  }
  if (!(normalized.doucheReceveurSansRessaut === DiagnosticReponse.Oui)) {
    normalized.doucheReceveurEncastre = undefined;
  }
  if (!(normalized.doucheReceveurEncastre === DiagnosticReponse.Oui)) {
    normalized.doucheReceveurEncastreOk = undefined;
  }
  if (!(normalized.lavaboProfondeur === DiagnosticReponse.Oui)) {
    normalized.lavaboUsage = undefined;
  }
  if (!(normalized.lavaboProfondeur === DiagnosticReponse.Oui)) {
    normalized.lavaboHauteurReglable = undefined;
  }
  if (!(normalized.lavaboProfondeur === DiagnosticReponse.Oui)) {
    normalized.lavaboHauteur = undefined;
  }
  if (!(normalized.lavaboProfondeur === DiagnosticReponse.Oui)) {
    normalized.lavaboLibreSous = undefined;
  }
  if (!(normalized.lavaboProfondeur === DiagnosticReponse.Oui)) {
    normalized.lavaboSiphon = undefined;
  }
  if (!(normalized.wcSepare === DiagnosticReponse.Oui)) {
    normalized.wcLargeurPorte80 = undefined;
  }
  if (!(normalized.wcSepare === DiagnosticReponse.Oui)) {
    normalized.wcLargeurPorte90 = undefined;
  }
  if (!(normalized.wcSepare === DiagnosticReponse.Oui)) {
    normalized.wcPoignetPorte = undefined;
  }
  if (!(normalized.wcPoignetPorte === DiagnosticReponse.Non)) {
    normalized.wcPoigneeRallongee = undefined;
  }
  if (!(normalized.wcSepare === DiagnosticReponse.Oui)) {
    normalized.wcEspaceManoeuvre = undefined;
  }
  if (!(normalized.wcSepare === DiagnosticReponse.Oui)) {
    normalized.wcPrisesHautes = undefined;
  }
  if (!(normalized.wcSepare === DiagnosticReponse.Oui)) {
    normalized.wcPrisesBasses = undefined;
  }

  return normalized;
}
